<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <BreadcrumbItem slot="parent" to="/communications">Communications</BreadcrumbItem>
        <BreadcrumbItem
          slot="parent"
          :to="'/contacts/' + communication.contact_id"
        >{{ contactName }}</BreadcrumbItem>
        <span slot="current">{{ isNew ? "New" : communication.gsn }}</span>
        <span slot="title">{{ isNew ? "New" : "Edit" }} Communication</span>
        <span slot="sub-title">{{ communication.subject }}</span>
      </AffixHeader>

      <i-form ref="form" :model="communication" :rules="rules" label-position="top">
        <i-form-item label="Contact">
          <i-input :value="contactName" readonly></i-input>
        </i-form-item>

        <i-form-item label="Subject" prop="subject">
          <i-input v-model="communication.subject"></i-input>
        </i-form-item>

        <Row>
          <i-col span="8">
            <i-form-item label="Tool" prop="title" style="padding-right: 6px;">
              <i-select v-model="communication.tool">
                <i-option value="Phone">Phone</i-option>
                <i-option value="Email">Email</i-option>
                <i-option value="Skype">Skype</i-option>
                <i-option value="Personal Meeting">Personal Meeting</i-option>
              </i-select>
            </i-form-item>
          </i-col>

          <i-col span="8">
            <i-form-item label="Date">
              <StringDatePicker
                v-model="communication.conducted_at"
                :options="dateFieldOptions"
                format="yyyy-MM-dd"
                style="width: 100%; padding-right: 6px;"
              />
            </i-form-item>
          </i-col>

          <i-col span="8">
            <i-form-item label="Country">
              <CountrySelect v-model="communication.iso3" :filterable="true"></CountrySelect>
            </i-form-item>
          </i-col>
        </Row>

        <i-form-item label="Content" prop="content">
          <i-input
            v-model="communication.content"
            type="textarea"
            spellcheck
            :autosize="{ minRows: 6, maxRows: 36 }"
            :rows="12"
          ></i-input>
        </i-form-item>

        <!-- Action Buttons -->
        <i-form-item class="action-buttons" v-if="$can('manage', 'communications')">
          <i-button type="primary" @click="save">
            <FFIcon type="save"/>
            {{ isNew ? "Create" : "Update" }}
          </i-button>
        </i-form-item>
      </i-form>
    </i-col>
    <LoadingSpinner :loading="loading"></LoadingSpinner>
  </Row>
</template>

<script>
import database from "@/database";
import CountrySelect from "@/components/country_select";

export default {
  components: {
    CountrySelect,
  },
  props: ["id", "contact_id"],

  data() {
    return {
      loading: false,
      communication: {
        subject: "",
        iso3: "",
        contact_id: null,
        conducted_at: "",
        tool: "",
        content: "",
      },
      contact: {
        title: "",
        name: "",
        surname: "",
      },
      rules: {},
      dateFieldOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
    };
  },

  created() {
    if (!!this.id) {
      this.load();
    } else if (!!this.contact_id) {
      this.communication.contact_id = parseInt(this.contact_id, 10);
      this.loadContact();
    }
  },

  computed: {
    isNew() {
      return !this.id;
    },
    contactName() {
      const contact = this.contact;
      return contact.title + " " + contact.name + " " + contact.surname;
    },
  },

  methods: {
    load() {
      if (!!this.id) {
        this.loading = true;
        database
          .load("communications", this.id, "*,contacts(*)")
          .then(res => {
            this.contact = res.data.contacts;
            delete res.data.contacts;
            this.communication = res.data;
            this.loading = false;
          })
          .catch(err => {
            console.error(err);
            this.loading = false;
          });
      }
    },
    loadContact() {
      if (!!this.contact_id) {
        this.loading = true;
        database
          .load("contacts", this.contact_id)
          .then(res => {
            this.contact = res.data;
            this.loading = false;
          })
          .catch(err => {
            console.error(err);
            this.loading = false;
          });
      }
    },
    save() {
      if (!this.$can("manage", "communications")) {
        this.$Message.error("User is not permitted");
        return;
      }
      const isNew = this.isNew;
      this.$refs["form"].validate(valid => {
        if (valid) {
          database
            .save("communications", this.communication, {})
            .then(res => {
              console.log(res);
              this.communication = res.data;
              this.loadingSuccess(
                isNew ? "Entry has been created" : "Entry has been updated"
              );
              this.$router.push(`/contacts/${this.communication.contact_id}`);
            })
            .catch(err => {
              console.error(err.response);
              this.loadingError(
                isNew ? "Failed to create entry" : "Failed to update entry"
              );
            });
        } else {
          this.$Message.error("Form errors!");
        }
      });
    },
  },
};
</script>

<style lang="css"></style>
